import React, { useState, useRef, useEffect } from "react";

const DropdownMenuServices = ({ label, items, buttonClass }) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={menuRef}>
      {/* Trigger button */}
      <button
        onClick={() => setOpen(!open)}
        className={`px-3 py-1 border border-border rounded-md text-sm flex items-center gap-1 ${buttonClass}`}
      >
        {label}
        <span className="ml-1 hidden lg:block">▾</span>
      </button>

      {/* Desktop Dropdown */}
      {open && (
        <div className="hidden md:block absolute right-0 mt-2 w-52 bg-dry border border-border rounded-md shadow-lg z-50">
          <ul className="text-sm text-text">
            {items.map((item, idx) =>
              item.divider ? (
                <li key={idx} className="border-t border-border my-1"></li>
              ) : (
                <li
                  key={idx}
                  onClick={item.onClick}
                  className="px-4 py-2 hover:bg-gray-100 hover:text-redlight cursor-pointer flex items-center gap-2"
                >
                  {item.icon && <span>{item.icon}</span>}
                  {item.label}
                </li>
              )
            )}
          </ul>
        </div>
      )}

      {/* Mobile Bottom Sheet */}
      {open && (
        <div className="fixed inset-0 z-50 flex items-end md:hidden">
          {/* Background overlay */}
          <div
            className="absolute inset-0 bg-black bg-opacity-40"
            onClick={() => setOpen(false)}
          ></div>

          {/* Bottom sheet */}
          <div className="relative w-full bg-dry rounded-t-lg shadow-lg p-4 max-h-[70%] overflow-y-auto animate-slide-up">
            <div className="flex justify-end">
              <button
                onClick={() => setOpen(false)}
                className="text-text text-lg font-bold"
              >
                ✕
              </button>
            </div>
            <ul className="text-sm text-text">
              {items.map((item, idx) =>
                item.divider ? (
                  <li key={idx} className="border-t border-border my-2"></li>
                ) : (
                  <li
                    key={idx}
                    onClick={item.onClick}
                    className="px-4 py-3 hover:bg-gray-100 cursor-pointer flex items-center gap-2"
                  >
                    {item.icon && <span>{item.icon}</span>}
                    {item.label}
                  </li>
                )
              )}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default DropdownMenuServices;
